import _sumBy from 'lodash/sumBy';

export const getRejectedParts = (state) => {
  return _sumBy(state.partAdjustments, 'scrapcount');
};
